/** Takes initialization tracking code and an optional async URL, and returns the HTML object suitable for React. */
export const getTrackingHTML =
  (...init: string[]) =>
  (src?: string | null | undefined) => ({
    __html:
      init.join(";") +
      (src
        ? `;document.head.append(Object.assign(document.createElement("script"),{async:!0,src:${JSON.stringify(src)}}))`
        : ``),
  })
